/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	invalidFormatValidationMessage,
	regularExpressionValidator
} from '@entity/entity-formly-definitions';
import {
	IValidator
} from '@shared/interfaces/application-objects/validator.interface';
import {
	BaseRuleValidator
} from '@shared/validators/base-rule-validator.validator';

/**
 * A class representing a regular expression validator.
 *
 * @export
 * @class RegularExpressionValidator
 * @extends {BaseRuleValidator}
 */
export class RegularExpressionValidator
	extends BaseRuleValidator
{
	/**
	 * Creates and returns a unique instance of a regular expression validator.
	 *
	 * @returns {IValidator}
	 * A validator ready for use in a Formly layout.
	 * @memberof RegularExpressionValidator
	 */
	public create(): IValidator
	{
		return <IValidator>
			{
				expression: regularExpressionValidator,
				message: invalidFormatValidationMessage
			};
	}
}